import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { TOAST_SETTINGS } from "../../utils/siteSettings";
import { pauseSubscription } from "./pauseSubscription";

const popupStyle = {
  position: "fixed",
  top: "0",
  left: "0",
  width: "100%",
  height: "100%",
  background: "rgba(0, 0, 0, 0.7)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: "999",
};

const contentStyle = {
  position: "relative",
  background: "#fff",
  borderRadius: "5px",
  width: "90%",
  maxWidth: "520px",
  padding: "24px",
  boxShadow: "0 5px 10px rgba(0, 0, 0, 0.3)",
};

const errorStyle = {
  color: "#b00020",
  background: "#fdecea",
  border: "1px solid #f5c2c0",
  padding: "10px 12px",
  borderRadius: "4px",
  marginBottom: "16px",
  fontSize: "14px",
};

const PausePopup = ({ onClose, planEndDate, defaultPauseFee }) => {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleConfirm = async () => {
    setError("");
    setSubmitting(true);
    try {
      const data = await dispatch(pauseSubscription());
      if (data?.status === 1) {
        toast.success(data?.msg || "Subscription paused.", TOAST_SETTINGS);
        onClose();
      } else {
        setError(data?.msg || "Unable to pause subscription.");
      }
    } catch (err) {
      setError(
        err?.response?.data?.msg ||
          err?.message ||
          "Unable to pause subscription. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={popupStyle}>
      <div style={contentStyle}>
        <h5 style={{ marginTop: 0, marginBottom: 12 }}>Pause your subscription?</h5>
        <p style={{ marginBottom: 16, fontSize: 14, lineHeight: 1.5 }}>
          You'll keep full access
          {planEndDate
            ? ` until ${planEndDate}`
            : " until your current plan expires"}
          .{" "}
          {defaultPauseFee != null ? (
            <>
              After that, a ${defaultPauseFee}/month holding fee preserves
              your profile, saved searches, and export history.{" "}
            </>
          ) : (
            <>
              After that, a small holding fee preserves your profile, saved
              searches, and export history.{" "}
            </>
          )}
          You can resume at any time.
        </p>

        {error && <div style={errorStyle}>{error}</div>}

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
          <button
            type="button"
            onClick={onClose}
            disabled={submitting}
            className="site_btn blank"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={submitting}
            className="site_btn"
          >
            {submitting ? "Pausing…" : "Pause Subscription"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PausePopup;
